let initialized = false

export async function initializeObservability() {
  if (initialized || import.meta.env.VITE_FARO_ENABLED !== 'true') return null
  const url = String(import.meta.env.VITE_FARO_URL || '').trim()
  if (!url) {
    console.warn('[observability] Faro is enabled but VITE_FARO_URL is empty.')
    return null
  }
  try {
    const { getWebInstrumentations, initializeFaro } = await import('@grafana/faro-web-sdk')
    const faro = initializeFaro({
      url,
      app: {
        name: import.meta.env.VITE_FARO_APP_NAME || 'bizerte-web',
        environment: import.meta.env.VITE_FARO_ENVIRONMENT || 'production',
        version: import.meta.env.VITE_APP_VERSION || 'unknown',
      },
      instrumentations: [...getWebInstrumentations({ captureConsole: false })],
      sessionTracking: { enabled: false },
    })
    initialized = true
    return faro
  } catch (error) {
    console.warn('[observability] Faro failed; the application continues normally.', error)
    return null
  }
}
